import { useAppSelector, useAppDispatch } from "@/services/hooks";
import { useCurrentPermission } from "@/services/userServices/useCurrentPermission";
// reactstrap components
import { Button, UncontrolledTooltip } from "reactstrap";
import React, { useEffect, useState } from "react";
import TableWrapper from "@/utils/TableWrapper";
import {
  getAll, deleteDesign, } from "@/services/designServices/designAction";

// react plugin for creating notifications over the dashboard
import { ToastContainer } from "react-toastify";
// react component used to create sweet alerts
import ReactBSAlert from "react-bootstrap-sweetalert";
import NotificationAlertOptions from "@/layouts/Alerts";
import { asCaught } from "@/services/caughtError";
import ReferrersDialog from "@/components/ReferrersDialog";
import { isDeleteRefusal, refusalMessage } from "@/services/deleteRefusal";
/** A design row as this list reads it. */
type DesignRow = { _id: string; name?: string; source?: string };

type DisplayDesignsProps = {
  handleUpdate: (design: unknown) => void;
};

const DisplayDesigns = (props: DisplayDesignsProps) => {
  const dispatch = useAppDispatch();
  //states
  const [alert, setAlert] = useState<React.ReactNode>(null);
  //store selectors
  const permission = useCurrentPermission();
  const designs = useAppSelector((state) => state.designs.designs) as DesignRow[];

  useEffect(() => {
    dispatch(getAll());
  }, []);
  const handleUpdateDesign = (elem) => (e) => {
    props.handleUpdate(elem);
  };
  const questionAlert = (design) => async (e) => {
    e.preventDefault();

    setAlert(
      // @ts-expect-error react-bootstrap-sweetalert prop-types (customIcon/btnSize)
      <ReactBSAlert
        custom
        style={{ display: "block", marginTop: "-100px" }}
        title="Delete design Operation"
        customIcon={
          <div
            className="swal2-icon swal2-question swal2-animate-question-icon text-warning"
            style={{ display: "flex" }}
          >
            <span className="swal2-icon-text">?</span>
          </div>
        }
        onConfirm={async () => {
          await setAlert(null);
          try {
            await dispatch(deleteDesign(design._id));
            notify("success");
          } catch (err) {
            // SCRUM-2356: refused because templates or sites still use the
            // design — the list instead of this screen's notification.
            const body = asCaught(err)?.response?.data;
            if (isDeleteRefusal(body)) {
              setAlert(
                <ReferrersDialog
                  message={refusalMessage(body)}
                  referrers={body.referrers}
                  onClose={() => setAlert(null)}
                />
              );
              return;
            }
            NotificationAlertOptions(
              "error",
              asCaught(err)?.response?.data?.message || "Deleting the design failed. Please try again."
            );
          }
        }}
        onCancel={() => setAlert(null)}
        confirmBtnBsStyle="warning"
        confirmBtnText="Yes I'm sure"
        btnSize=""
      >
        Are you sure to delete {" " + design.name + " "} design
      </ReactBSAlert>
    );
  };
  const notify = (type) => {
    NotificationAlertOptions(type, "Design deleted successfully");
  };
  // SCRUM-2115: the list renders through TableWrapper (search, paging, sort,
  // aria-sort) like every other admin list. SCRUM-1225 removed the "Setting
  // variables" column with the design-level settings it counted.
  const canAct = permission.publish || permission.edit;
  const columns = [
    {
      accessorKey: "name",
      header: "Name",
      cell: ({ row }: { row: { original: DesignRow } }) => (
        <span className="text-muted">
          <strong> {row.original.name}</strong>
        </span>
      ),
    },
    {
      accessorKey: "source",
      header: "Source",
      cell: ({ row }: { row: { original: DesignRow } }) => (
        <a
          className="font-weight-bold"
          href="#pablo"
          onClick={(e) => e.preventDefault()}
        >
          {row.original.source}
        </a>
      ),
    },
    ...(canAct
      ? [
          {
            id: "actions",
            header: "Actions",
            enableSorting: false,
            enableGlobalFilter: false,
            cell: ({ row }: { row: { original: DesignRow } }) => {
              const element = row.original;
              return (
                <>
                    <UncontrolledTooltip
                      delay={0}
                      trigger="hover focus"
                      target={`tooltip${element._id}`}
                    >
                      Delete
                    </UncontrolledTooltip>
                    <UncontrolledTooltip
                      delay={0}
                      trigger="hover focus"
                      target={`tooltip1${element._id}`}
                    >
                      update
                    </UncontrolledTooltip>
                    <Button
                      className="mr-3"
                      onClick={handleUpdateDesign(element)}
                      size="sm"
                      id={`tooltip1${element._id}`}
                    >
                      <i className="ni ni-settings-gear-65" />
                    </Button>
                    <Button
                      className="mr-4"
                      color="danger"
                      onClick={questionAlert(element)}
                      size="sm"
                      id={`tooltip${element._id}`}
                    >
                      <i className="fas fa-trash" />
                    </Button>
                </>
              );
            },
          },
        ]
      : []),
  ];
  return (
    <>
      <div className="rna-wrapper">
      <ToastContainer />
      </div>
      {alert}
      <TableWrapper data={designs} columns={columns} searchLabel="Search designs" />
    </>
  );
};
export default DisplayDesigns;
